import styled from "styled-components";
import Overlay from "../../../Componentes/Overlay";
import Modal from "../../../Componentes/Utils/Modal";
import useApi from "../../../hooks/useApi";
import { useState } from "react";

const Titulo = styled.h2`
    margin: 0 0 15px 0;
    font-size: 18px;
    color: #333;
    text-align: center;
`
const Subtitulo = styled.p`
    margin: 0;
    font-size: 14px;
    color: #555;
    text-align: center;
`
const BotoesWrapper = styled.div`
    margin-top: 35px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
`
const Botao = styled.button`
    padding: 9px 12px;
    background-color: ${props => props.cancel ? '#e5e7eb' : '#2563eb'};
    color: ${props => props.cancel ? '#333' : 'white'};
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: .2s all ease;
    &:disabled {
        background-color: ${props => props.cancel ? '#e5e7eb' : '#93c5fd'};
        cursor: auto;
    }
`

const ConfirmDeleteAnexoPC = ({ id, isPedido = true, fecharModal, onDelete }) => {

    const api = useApi();

    const [saving, setSaving] = useState(false);

    const handleDelete = async () => {

        setSaving(true);

        try {

            const path = isPedido
                ? `/Painel/API/ControleMedicao/DeletePCAnexo/index.php?id=${id}`
                : `/Painel/API/ControleMedicao/DeleteADTVAnexo/index.php?id=${id}`;

            await api.post(path);

            onDelete();
            fecharModal();

        } catch (error) {

            console.error("Erro ao excluir anexo:", error);

        } finally {

            setSaving(false);

        }

    }

    return (
        <Overlay state={true}>
            <Modal size="sm">
                <Titulo>Confirmar exclusão</Titulo>
                <Subtitulo>Tem certeza que deseja excluir este arquivo?</Subtitulo>
                <BotoesWrapper>
                    <Botao cancel type="button" onClick={fecharModal} disabled={saving}>CANCELAR</Botao>
                    <Botao type="button" onClick={handleDelete} disabled={saving}>EXCLUIR</Botao>
                </BotoesWrapper>
            </Modal>
        </Overlay>
    );
}

export default ConfirmDeleteAnexoPC;
